module.exports = __webpack_public_path__ + "static/media/LCScriptWeb-Regular.12e93121.woff";